export type TrackingCategory = "analytics" | "marketing";
export type TrackingConsent = {
  analytics: boolean;
  marketing: boolean;
  revision: string | null;
};

// Stesso contratto del banner: valori parziali, stringhe e JSON non valido
// non sono una concessione. La revisione impedisce il replay dopo una revoca.
export function readTrackingConsent(): TrackingConsent {
  try {
    const raw = localStorage.getItem("cookie_consent");
    const prefs = JSON.parse(raw || "null");
    if (prefs && typeof prefs.necessary === "boolean" &&
        typeof prefs.analytics === "boolean" && typeof prefs.marketing === "boolean" &&
        typeof prefs.timestamp === "number" && Number.isFinite(prefs.timestamp)) {
      return { analytics: prefs.analytics, marketing: prefs.marketing, revision: raw };
    }
  } catch { /* Storage bloccato o preferenze non valide: nessun consenso opzionale. */ }
  return { analytics: false, marketing: false, revision: null };
}

export function consentStillValid(snapshot: TrackingConsent, category: TrackingCategory): boolean {
  const current = readTrackingConsent();
  return snapshot[category] && current[category] && snapshot.revision === current.revision;
}
